import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  deleteAImageFeed,
  getImageFeeds,
  resetState,
} from "../features/imageFeed/imageFeedSlice";
import CustomModal from "../components/CustomModal";
import { resolveMediaUrl } from "../utils/mediaUrl";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Link",
    dataIndex: "link",
    render: (text) => (
      <a href={text} target="_blank" rel="noopener noreferrer">
        {text.length > 40 ? `${text.slice(0, 40)}...` : text}
      </a>
    ),
  },
  {
    title: "Image",
    dataIndex: "image",
    render: (text) => (
      <img
        src={resolveMediaUrl(text)}
        alt=""
        width={50}
        height={50}
        style={{ objectFit: "cover" }}
      />
    ),
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Order",
    dataIndex: "order",
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const ImageFeedList = () => {
  const [open, setOpen] = useState(false);
  const [feedId, setFeedId] = useState("");
  const [loading, setLoading] = useState(true);

  const showModal = (id) => {
    setOpen(true);
    setFeedId(id);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await dispatch(resetState());
      await dispatch(getImageFeeds());
      setLoading(false);
    };
    fetchData();
  }, [dispatch]);

  const feedStat = useSelector((state) => state.imageFeed.imageFeeds);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  const data1 = feedStat.map((item, index) => ({
    key: index + 1,
    link: item.link,
    image: item.feed_image,
    status: item.status,
    order: item.order,
    action: (
      <>
        <Link
          to={`/admin/image-feed/${item._id}`}
          className="fs-3 text-danger"
        >
          <BiEdit />
        </Link>
        <button
          className="ms-3 fs-3 text-danger bg-transparent border-0"
          onClick={() => showModal(item._id)}
        >
          <AiFillDelete />
        </button>
      </>
    ),
  }));

  const deleteFeed = (id) => {
    dispatch(deleteAImageFeed(id));
    setOpen(false);
    setTimeout(() => {
      dispatch(getImageFeeds());
    }, 100);
  };

  return (
    <div>
      <h3 className="mb-4 title">Image Feed List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => deleteFeed(feedId)}
        title="Are you sure you want to delete this image feed item?"
      />
    </div>
  );
};

export default ImageFeedList;
